import React from 'react'

export default function IconsPersonAdd({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'

    return (
        <svg
            style={style}
            className={className}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1.6665 17.5C1.66643 16.217 2.03662 14.9612 2.73262 13.8833C3.42863 12.8054 4.4209 11.9513 5.59034 11.4234C6.75977 10.8955 8.0567 10.7163 9.32547 10.9073C10.5942 11.0983 11.7809 11.6513 12.7432 12.5'
                stroke={fillColor}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.33317 10.8333C10.6344 10.8333 12.4998 8.96785 12.4998 6.66667C12.4998 4.36548 10.6344 2.5 8.33317 2.5C6.03198 2.5 4.1665 4.36548 4.1665 6.66667C4.1665 8.96785 6.03198 10.8333 8.33317 10.8333Z'
                stroke={fillColor}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15.8335 13.3333V18.3333'
                stroke={fillColor}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M18.3335 15.8333H13.3335'
                stroke={fillColor}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
